"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpAuth = void 0;
const inversify_1 = require("inversify");
const Oauth2Client = require("client-oauth2");
const core_1 = require("@vacasa/core");
let IdpAuth = class IdpAuth {
    constructor(loggingService) {
        this.loggingService = loggingService;
        this.logger = loggingService === null || loggingService === void 0 ? void 0 : loggingService.getLogger("IdpAuth");
    }
    static getId() {
        return core_1.IdpServiceNS.IDP_SERVICE_ID;
    }
    async getToken(idpConfiguration, serviceConfiguration) {
        var _a;
        const CLIENT = new Oauth2Client({
            clientId: idpConfiguration.clientId,
            clientSecret: idpConfiguration.clientSecret,
            accessTokenUri: idpConfiguration.url,
            scopes: serviceConfiguration.scope,
            body: { audience: Array.isArray(serviceConfiguration.audience) ? serviceConfiguration.audience.join(" ") : serviceConfiguration.audience },
        });
        try {
            return await CLIENT.credentials.getToken();
        }
        catch (err) {
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.error("Getting IDP token failed", err);
            throw err;
        }
    }
};
IdpAuth = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(core_1.LoggingServiceNS.LOGGING_SERVICE_ID)), __param(0, inversify_1.optional()),
    __metadata("design:paramtypes", [Object])
], IdpAuth);
exports.IdpAuth = IdpAuth;
//# sourceMappingURL=idp.auth.js.map